import { render, staticRenderFns } from "./CTranslatorButton.vue?vue&type=template&id=051e5074&scoped=true&"
import script from "./CTranslatorButton.vue?vue&type=script&lang=js&"
export * from "./CTranslatorButton.vue?vue&type=script&lang=js&"
import style0 from "./CTranslatorButton.vue?vue&type=style&index=0&id=051e5074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051e5074",
  null
  
)

export default component.exports